export default "__VITE_ASSET__CcWSb977__"